var render, staticRenderFns
import script from "./Loading.vue?vue&type=script&lang=tsx&"
export * from "./Loading.vue?vue&type=script&lang=tsx&"
import style0 from "./Loading.vue?vue&type=style&index=0&id=63dc4205&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dc4205",
  null
  
)

export default component.exports